import { createApi } from "@reduxjs/toolkit/query/react";

import { generatedApiBaseQuery } from "./sprengConnectApi/sprengConnectApiBaseQuery";

export const emptyGeneratedApi = createApi({
  reducerPath: "generatedApi",
  baseQuery: generatedApiBaseQuery,
  endpoints: () => ({}),
});
